export default __webpack_public_path__ + "static/media/093-diagonal-arrow-4.168b0013.png";